import { render } from "./HeroiconsSolidUser.vue?vue&type=template&id=481da53e"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUser.vue"]])

export default __exports__